import  {useRef,useState,useEffect} from 'react'
import React, {   useParams } from 'react-router-dom';
import MHeader from './header';
import Mfooter from './footer';

// MODIFICA: Importiamo la libreria da un CDN (esm.sh) per permettere l'esecuzione in questo ambiente.
// Nel tuo progetto locale, dovrai eseguire: npm install @xeokit/xeokit-sdk
import { Viewer, XKTLoaderPlugin, NavCubePlugin } from "https://esm.sh/@xeokit/xeokit-sdk";
//import { Viewer, XKTLoaderPlugin, NavCubePlugin } from '@xeokit/xeokit-sdk'
import config from './config';
import { Layers, Loader2, ChevronDown, ChevronUp } from 'lucide-react'; 
/**
 * Componente per visualizzare modelli 3D in formato .xkt
 * @param {string} url - L'URL (blob o remoto) del file .xkt da visualizzare
 */
const XKTViewer = () => {
  const { url } = useParams();
  const {id} = useParams();
  const {desc} = useParams();
  const canvasRef = useRef(null);
  const viewerRef = useRef(null);
  const [loading, setLoading] = useState(false);

    const objectTypeMap = useRef({});

const [layers, setLayers] = useState({});
  const [showLayerPanel, setShowLayerPanel] = useState(false);

  useEffect(() => {
    // Se non c'è il canvas o l'url è vuoto, non fare nulla
    if (!canvasRef.current || !url) return;

    setLoading(true);

    try {
      // 1. Inizializza il Viewer di xeokit
      const viewer = new Viewer({
        canvasElement: canvasRef.current,
        transparent: true,
        backgroundColor: [1, 1, 1], // Sfondo bianco (opzionale)
      });
      
      // Salva il riferimento per il cleanup
      viewerRef.current = viewer;

      // Imposta la camera (opzionale)
      viewer.camera.eye = [-3.93, 2.85, 27.01];
      viewer.camera.look = [4.40, 3.72, 8.89];
      viewer.camera.up = [-0.01, 0.99, 0.03];

      // 2. Aggiungi il Loader per i file XKT
      const xktLoader = new XKTLoaderPlugin(viewer);

      // (Opzionale) Aggiungi un cubo di navigazione in basso a destra
      new NavCubePlugin(viewer, {
        canvasId: "myNavCubeCanvas",
        visible: true,
        size: 150,
        alignment: "bottomRight",
        bottomMargin: 20,
        rightMargin: 20
      });

      // 3. Carica il modello
      const model = xktLoader.load({
        id: "myModel",
        src: config.apiUrl+"/scarica-allegato/" + id +"/"+url,//config.apiUrl+"/get"+id+"/"+url,
        edges: true, // Mostra i bordi degli oggetti (migliora la visibilità CAD)
        performance: true // Ottimizza per modelli grandi
      });

      // Evento: Quando il modello è caricato
      model.on("loaded", () => {
        setLoading(false);
        // Vola con la camera per inquadrare tutto il modello
        viewer.cameraFlight.flyTo(model);


           // --- ESTRAZIONE E MAPPATURA LAYER (TIPI IFC) ---
        const foundLayers = {};
        const tempTypeMap = {}; // Mappa temporanea per accumulare gli ID
        const metaObjects = viewer.metaScene.metaObjects;

        // Scansioniamo tutti gli oggetti per trovare i tipi unici e i relativi ID
        for (const objectId in metaObjects) {
          const metaObject = metaObjects[objectId];
          if (metaObject.type && metaObject.type !== 'default') {
            // Inizializziamo il layer come visibile (true)
            foundLayers[metaObject.type] = true; 
            
            // Aggiungiamo l'ID alla lista di quel tipo
            if (!tempTypeMap[metaObject.type]) {
                tempTypeMap[metaObject.type] = [];
            }
            tempTypeMap[metaObject.type].push(objectId);
          }
        }
        

        // Salviamo la mappa completa nel ref per usarla in toggleLayer
        objectTypeMap.current = tempTypeMap;
        if (Object.keys(foundLayers).length === 0) {
            console.warn("Nessun oggetto IFC trovato (sei in modalità mock?), aggiungo layer di test.");
            setLayers({
                'IfcWall': true,
                'IfcWindow': true,
                'IfcDoor': true,
                'IfcSlab': true,
                'IfcFurnishingElement': false
            });
            // Mock map per testare il toggle senza crash
            objectTypeMap.current = {
                'IfcWall': [], 'IfcWindow': [], 'IfcDoor': [], 'IfcSlab': [], 'IfcFurnishingElement': []
            };
        } else {
            setLayers(foundLayers);
        }
      });

      // Gestione Errori
      model.on("error", (e) => {
        console.error("Errore caricamento XKT:", e);
        setLoading(false);
        alert("Impossibile caricare il modello 3D.");
      });

    } catch (err) {
      console.error("Errore inizializzazione Viewer:", err);
      setLoading(false);
    }

    // 4. Cleanup: Distruggi il viewer quando il componente viene smontato
    // o quando l'URL cambia (per ricrearlo pulito)
    return () => {
      if (viewerRef.current) {
        viewerRef.current.destroy();
        viewerRef.current = null;
      }
    };

  }, [url]); // Riesegui se l'URL cambia

  const toggleLayer = (type) => {
    // Aggiorna stato UI
    const isVisible = !layers[type];
    setLayers(prev => ({ ...prev, [type]: isVisible }));

    // Aggiorna Xeokit
    if (viewerRef.current) {
      // Recupera gli ID dalla mappa che abbiamo costruito al caricamento
      const objectIds = objectTypeMap.current[type];
      
      if (objectIds && objectIds.length > 0) {
        viewerRef.current.scene.setObjectsVisible(objectIds, isVisible);
      } else {
          console.log(`[Xeokit] Nessun oggetto trovato per ${type} o layer vuoto.`);
      }
    }
  };

  return (
    <div>

    
      <MHeader />
      <h1>{desc}</h1>
      <div style={{ position: 'relative', width: '100%', height: '600px', background: '#f0f0f0' }}>
      
      {/* Indicatore di caricamento */}
      {loading && (
        <div style={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          zIndex: 10, color: '#333', fontWeight: 'bold'
        }}>
          Caricamento Modello 3D...
        </div>
      )}

      {/* Il Canvas principale per il 3D */}
      <canvas 
        ref={canvasRef} 
        style={{ width: '100%', height: '100%', outline: 'none' }} 
      />
      
      {/* Canvas per il Cubo di Navigazione (NavCube) */}
      <canvas
        id="myNavCubeCanvas"
        style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 2, width: '150px', height: '150px' }}
      />
    </div>

  {!loading && Object.keys(layers).length > 0 && (
          <div 
            className={`absolute top-4 left-4 w-64 bg-white shadow-2xl rounded-lg z-30 transition-all duration-300 border border-slate-200 flex flex-col`}
            style={{ 
              // Usa maxHeight dinamico per l'animazione di apertura/chiusura
              // calc(100% - 32px) assicura che non esca dal contenitore padre (top:4 + padding bottom)
              maxHeight: showLayerPanel ? 'calc(100% - 32px)' : '48px',
              overflow: 'hidden' 
            }}
          >
            
            {/* Header del Pannello */}
            <button 
                onClick={() => setShowLayerPanel(!showLayerPanel)}
            >
                <div className="flex items-center gap-2">
                    <Layers size={18} />
                    <span className="font-bold text-sm text-slate-700">Layer BIM</span>
                </div>
                {showLayerPanel 
                  ? <ChevronUp size={16} className="text-slate-400"/> 
                  : <ChevronDown size={16} className="text-slate-400"/>
                }
            </button>
{Object.values(layers).filter(v => v).length} visibili su {Object.keys(layers).length}  
            {/* Lista Layer con CHECKBOX */}
            <div className="overflow-y-auto p-2 space-y-1 bg-white">
                {Object.keys(layers).sort().map((type) => (
                    <label
                        key={type}
                        className={`flex items-center p-2 rounded-md text-sm transition-all cursor-pointer select-none group ${
                            layers[type] 
                            ? 'bg-blue-50/50 hover:bg-blue-50' 
                            : 'hover:bg-slate-50 opacity-60 hover:opacity-100'
                        }`}
                    >
                        <div className="relative flex items-center justify-center w-5 h-5 mr-3">
                          <input
                              type="checkbox"
                              checked={layers[type]}
                              onChange={() => toggleLayer(type)}
                              className="peer appearance-none w-4 h-4 border border-slate-300 rounded bg-white checked:bg-blue-600 checked:border-blue-600 cursor-pointer transition-colors"
                          />
                         
                        </div>
                        
                        <span className={`truncate text-sm ${layers[type] ? 'text-slate-700 font-medium' : 'text-slate-500'}`} title={type}>
                            {type.replace('Ifc', '')}
                        </span>
                    </label>
                ))}
            </div>
            
            {/* Footer Pannello */}
            <div className="p-2 bg-slate-50 border-t border-slate-100 text-[10px] text-center text-slate-400 flex-shrink-0">
                
            </div>
          </div>
        )}


    <Mfooter />
    </div>
  );
};

export default XKTViewer;